class PlatformARENA {
  constructor({ region, accessToken, arenaToken, code }) {
    this.type = 'arena'
    this.region = region
    this.accessToken = accessToken
    this.arenaToken = arenaToken
    this.code = code
  }

  get regionType() {
    return this.region ? `${this.type}_${this.region}` : ''
  }

  getAuthorization() {
    if (this.accessToken) {
      return `Arena ${this.accessToken}`
    } else if (this.arenaToken) {
      return `ArenaToken ${this.arenaToken}`
    }
  }

  getWebTokenBody() {
    return { 
      access_token: this.accessToken,
      arena_token: this.arenaToken,
      code: this.code,
      arena_region_type: this.regionType,
    }
  }
  
  clear() {
    this.arenaToken = null
  }

  /**
   * AToken 값을 검증합니다.
   * @returns {Boolean}
   */
  isValidSession() {
    return !!this.accessToken || !!this.arenaToken || !!this.code
  }
}

export default PlatformARENA